/**
 * cg_track.js
 * Laden via theme.liquid vóór </body>
 *
 * Verantwoordelijkheden:
 * 1. Shopify Customer Privacy API laden en event dispatchen
 * 2. msclkid opvangen, opslaan in sessionStorage en posten als cart attribute
 */
 
// ─────────────────────────────────────────────
// 1. SHOPIFY CONSENT API — laden & dispatchen
// ─────────────────────────────────────────────
 
window.Shopify.loadFeatures([
  { name: 'consent-tracking-api', version: '0.1' }
], function(error) {
  if (error) {
    console.error('[Consent] API niet geladen:', error);
    return;
  }
 
  const detail = {
    marketingAllowed: window.Shopify.customerPrivacy.marketingAllowed(),
    analyticsAllowed: window.Shopify.customerPrivacy.analyticsProcessingAllowed()
  };
 
  document.dispatchEvent(new CustomEvent('cargoodsConsentReady', { detail }));

});
 
 
// ─────────────────────────────────────────────
// 2. MSCLKID — opvangen & cart attribute zetten
// ─────────────────────────────────────────────
 
(function() {
  const urlParams = new URLSearchParams(window.location.search);
  const msclkid = urlParams.get('msclkid');
  if (!msclkid) return;
 
  // Altijd tijdelijk opslaan in sessionStorage — nog geen tracking-doel
  sessionStorage.setItem('cg_pending_msclkid', msclkid);
})();
 
function handleMsclkidConsent(marketingAllowed) {
  if (!marketingAllowed) return;
 
  const msclkid = sessionStorage.getItem('cg_pending_msclkid');
  if (!msclkid) return;
 
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      attributes: { cg_msclkid: msclkid }
    })
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    sessionStorage.removeItem('cg_pending_msclkid');
  })
  .catch(function(err) {
    console.error('[cg_msclkid] Cart update mislukt:', err);
  });
}

// Consent beschikbaar bij laden
if (window.Shopify?.customerPrivacy) {
  handleMsclkidConsent(window.Shopify.customerPrivacy.marketingAllowed());
} else {
  document.addEventListener('cargoodsConsentReady', function(event) {
    handleMsclkidConsent(event.detail.marketingAllowed);
  });
}
 
// Consent-update (gebruiker handelt banner later af)
document.addEventListener('visitorConsentCollected', function(event) {
  handleMsclkidConsent(event.detail?.marketingAllowed);
});


// ─────────────────────────────────────────────
// 3. MSCLKID — tag loader
// ─────────────────────────────────────────────
 
function initUet(marketingAllowed) {
  // Harde block
  if (!marketingAllowed) return;

  if (window.__uetInitialized) return;
  window.__uetInitialized = true;

  window.uetq = window.uetq || [];
 
  // Consent default — initiële status vóór gebruikersinteractie
  window.uetq.push('consent', 'default', {
    ad_storage: marketingAllowed ? 'granted' : 'denied'
  });
 
  (function(w,d,t,u,o){w[u]=w[u]||[],o.ts=(new Date).getTime();var n=d.createElement(t); n.src="https://bat.bing.net/bat.js?ti="+o.ti+("uetq"!=u?"&q="+u:""),n.async=1, n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&"loaded"!==s&&"complete"!==s||( o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad"),n.onload=n.onreadystatechange=null)}; var i=d.getElementsByTagName(t)[0];i.parentNode.insertBefore(n,i); })(window,document,"script","uetq",{ti:"355054676", enableAutoSpaTracking: false});
}
 
function updateUetConsent(marketingAllowed) {
  if (!window.__uetInitialized) {
    initUet(marketingAllowed);
    return;
  }

  // Consent update — na expliciete keuze in de banner
  window.uetq.push('consent', 'update', {
    ad_storage: marketingAllowed ? 'granted' : 'denied'
  });
} 

// Consent beschikbaar bij laden
if (window.Shopify?.customerPrivacy) {
    initUet(window.Shopify.customerPrivacy.marketingAllowed());
} else {
    document.addEventListener('cargoodsConsentReady', function(event) {
        initUet(event.detail.marketingAllowed);
    });
}
 
// Consent-update (gebruiker handelt banner later af)
document.addEventListener('visitorConsentCollected', function(event) {
    updateUetConsent(event.detail?.marketingAllowed);
});

// ─────────────────────────────────────────────
// 4. Add to cart - Event listener for UET
// ─────────────────────────────────────────────

document.addEventListener('submit', function(event) {
  const form = event.target;
  if (form.getAttribute('data-type') !== 'add-to-cart-form') return;
  if (!window.__uetInitialized) return;
  
  const variantId = form.querySelector('input[name="id"][ref="variantId"]')?.value;

  window.uetq = window.uetq || [];
  window.uetq.push('event', 'add_to_cart', {
    event_category: 'ecommerce',
    event_label: variantId
  });
});